import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,      // 5 min
      gcTime: 10 * 60 * 1000,         // 10 min
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const queryKeys = {
  orders: ['orders'] as const,
  order: (id: number) => ['order', id] as const,
  orderList: (filters: string) => ['orders', 'list', filters] as const,
  myOrders: ['orders', 'my'] as const,
  myOrderList: (filters: string) => ['orders', 'my', 'list', filters] as const,
  myOrder: (id: number) => ['orders', 'my', id] as const,
  myOrderQr: (id: number) => ['orders', 'my', id, 'qr'] as const,
  notifications: ['notifications'] as const,
  notificationList: (filters: string) => ['notifications', 'list', filters] as const,
  unreadCount: ['notifications', 'unread-count'] as const,
  me: ['user', 'me'] as const,
  imports: ['imports'] as const,
  importHistory: (page: number) => ['imports', 'history', page] as const,
  importDetail: (id: number) => ['imports', id] as const,
  importBatchDetail: (id: number) => ['imports', 'batch', id] as const,
  shortages: ['shortages'] as const,
  shortageList: (filters: string) => ['shortages', 'list', filters] as const,
  stock: ['stock'] as const,
  movements: (filters: string) => ['movements', filters] as const,
  inventoryChecks: ['inventory-checks'] as const,
  inventoryCheck: (id: number) => ['inventory-checks', id] as const,
  checkReport: (id: number) => ['inventory-checks', id, 'report'] as const,
  deliverySheets: ['delivery-sheets'] as const,
  deliverySheet: (id: number) => ['delivery-sheets', id] as const,
  adminStats: ['admin', 'stats'] as const,
  adminBranches: (filters: string) => ['admin', 'branches', filters] as const,
  adminBranch: (id: number) => ['admin', 'branches', id] as const,
  branchSettings: ['branch-settings'] as const,
  billingStatus: ['billing', 'status'] as const,
  billingPayments: ['billing', 'payments'] as const,
};
